import { gql } from "lib/apolloClient";
import { organizationFragment } from "./Fragment";

export const getOrganizationCurriculumProgramsByAcademicYearQuery = gql`
  query getOrganizationCurriculumPrograms(
    $organizationId: ID!
    $academicYearId: ID!
    $entityFilters: EntityCountInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...curriculumProgramsItem
      }
    }
  }
  ${organizationFragment.curriculumPrograms}
`;
